export default function convertToComparatorReturnValue(result: number): 0 | 1 | -1 {
  if (result < 0) return -1;
  if (result > 0) return 1;
  return 0;
}
